import { kevinAuthAPI } from 'apis/config';

export const emoticonApis = {
  emoticonList: (projectId) =>
    kevinAuthAPI
      .get(`/resource-manager/emoticon/${projectId}/`)
      .then((res) => res.data),
  emoticonGroupCreate: (projectId, data) =>
    kevinAuthAPI
      .post(`/resource-manager/emoticon/${projectId}`, data)
      .then((res) => res.data),
  emoticonGroupEdit: (projectId, id, data) =>
    kevinAuthAPI
      .patch(`/resource-manager/emoticon/${projectId}/${id}`, data)
      .then((res) => res.data),
  emoticonAssetUpload: (projectId, id, data) =>
    kevinAuthAPI
      .put(`/resource-manager/emoticon/${projectId}/${id}`, data)
      .then((res) => res.data),
  emoticonAssetEditName: (projectId, id, slaveId, data) =>
    kevinAuthAPI
      .patch(`/resource-manager/emoticon/${projectId}/${id}/${slaveId}`, data)
      .then((res) => res.data),
  emoticonAssetEditImage: (projectId, id, slaveId, data) =>
    kevinAuthAPI
      .put(`/resource-manager/emoticon/${projectId}/${id}/${slaveId}`, data)
      .then((res) => res.data),
  emoticonDeleteGroup: (projectId, id) =>
    kevinAuthAPI
      .delete(`/resource-manager/emoticon/${projectId}/${id}`)
      .then((res) => res.data),
  emoticonDeleteAsset: (projectId, id, slaveId) =>
    kevinAuthAPI
      .delete(`/resource-manager/emoticon/${projectId}/${id}/${slaveId}`)
      .then((res) => res.data),
};
